import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { catchError, finalize, of, tap } from 'rxjs';
import { CommonFunctions } from 'src/app/shared/utilities/common-functions';
import { ShellService } from '../services/shell.service';
import { ToastrService } from 'ngx-toastr';
import { CommonConstants } from 'src/app/shared/constants/common-constants';

export const ShellDataResolver: ResolveFn<any> = () => getResolverData();

const getResolverData = (
  commonFunctions = inject(CommonFunctions),
  shellService = inject(ShellService),
  toastr = inject(ToastrService)
) => {
  commonFunctions.showLoading();
  return shellService.loadData$().pipe(
    tap(() => shellService.setShellDataLoaded(true)),
    finalize(() => commonFunctions.hideLoading()),
    catchError((error) => {
      commonFunctions.handleErrorResponse(error, toastr, CommonConstants.UnableToLoadData);
      return of([]);
    })
  );
};
